import { __awaiter, __generator } from "tslib";
var callbackCacheBooster = 100000;
/**
 * @internal
 */
export var jsonp = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                var scriptElement = document.createElement('script');
                var callbackName = "_jsonp_" + Math.round(callbackCacheBooster * Math.random());
                //url formatting
                if (url.match(/\?/)) {
                    url += "&callback=" + callbackName;
                }
                else {
                    url += "?callback=" + callbackName;
                }
                scriptElement.src = url;
                window[callbackName] = function (data) {
                    resolve(data);
                    document.body.removeChild(scriptElement);
                    delete window[callbackName];
                };
                document.body.appendChild(scriptElement);
            })];
    });
}); };
